module.exports = "img/prac-info-slide-5.2ec5e4.jpeg";